/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Confirm_Carrier_ChangeInputs */

const en_orders_confirm_carrier_change = /** @type {(inputs: Orders_Confirm_Carrier_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Carrier Change`)
};

const es_orders_confirm_carrier_change = /** @type {(inputs: Orders_Confirm_Carrier_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar cambio de transportista`)
};

/**
* | output |
* | --- |
* | "Confirm Carrier Change" |
*
* @param {Orders_Confirm_Carrier_ChangeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_confirm_carrier_change = /** @type {((inputs?: Orders_Confirm_Carrier_ChangeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Confirm_Carrier_ChangeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_confirm_carrier_change(inputs)
	return es_orders_confirm_carrier_change(inputs)
});